"use strict";

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkAppSupport = exports.callNativeAjax = void 0;

var _cookie2 = _interopRequireDefault(require("@zz-common/zz-utils/lib/cookie"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.promise.js");

require("core-js/modules/es.array.find.js");

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.array.for-each.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.regexp.exec.js");

var _utils = require("./utils");

var _setCookieParser = require("./set-cookie-parser");

var _bridgev = require("./bridgev1");

var _bridgev2 = require("./bridgev2");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var cache = {}; // export const checkAppSupport = (req) => Promise.resolve({...req, noSupport:1});
// export const callNativeAjax = (req) => Promise.resolve({code: 1, data: {a:1}});
// 判断端内环境是否支持 onAjaxRequest

var checkAppSupport = function checkAppSupport(request) {
  return new Promise(function (resolve) {
    function cb(res) {
      if (res && res.code == 1) {
        if (_utils.isIOS && !(0, _utils.isZZThan9_14)()) {
          (0, _utils.logWarn)('该 IOS 版本 App 不支持 native 请求');
          cache['noSupport'] = true;
          return resolve(_objectSpread(_objectSpread({}, request), {}, {
            noSupport: true
          }));
        }

        cache['noSupport'] = false;
        return resolve(_objectSpread(_objectSpread({}, request), {}, {
          noSupport: false
        }));
      }

      (0, _utils.logWarn)('该版本 App 不支持 native 请求, 降级为 ajax');
      cache['noSupport'] = true;
      resolve(_objectSpread(_objectSpread({}, request), {}, {
        noSupport: true
      }));
    }

    if (cache['noSupport'] !== undefined) {
      (0, _utils.logInfo)('cache[noSupportNativeRequest]', cache['noSupport']);
      return resolve(_objectSpread(_objectSpread({}, request), {}, {
        noSupport: cache['noSupport']
      }));
    }

    if (!(0, _utils.canUseNativeWinSdk)()) {
      (0, _utils.logWarn)('该版本 App 不支持 native 代理请求, 降级为 ajax');
      cache['noSupport'] = true;
      return resolve(_objectSpread(_objectSpread({}, request), {}, {
        noSupport: true
      }));
    } // jsb-hasSupportFeature 判断是否支持 onAjaxRequest, 
    // bug-fix 单独判断转转 ios >= 9.13.0 支持


    var key = 'hasSupportFeature';
    var param = {
      method: 'onAjaxRequest'
    };
    (0, _bridgev.newInvokeIosV1)(key, param, (0, _bridgev.getCallbackNameV1)(cb, false, key));
  });
}; // tip: 稳定性需要多验证


exports.checkAppSupport = checkAppSupport;

var handleSetCookie = function handleSetCookie(headers) {
  var cookieKey = Object.keys(headers).find(function (v) {
    return v.toLowerCase() === 'set-cookie';
  });
  var setCookies = cookieKey && headers.cookieKey;

  if (window.document && setCookies) {
    // 遍历 setCookies 进行 cookie.set
    try {
      (0, _setCookieParser.parse)(setCookies).forEach(function (v) {
        // 
        var _v = _objectSpread({}, v);

        delete _v.name;
        delete _v.value; // try {
        //   Cookie.remove(v.name, _v);
        // } catch (error) {}

        _cookie2.default.set(v.name, v.value, _v);
      });
    } catch (error) {
      (0, _utils.logWarn)(error);
    }
  }
}; // 调用 native 请求


var callNativeAjax = function callNativeAjax(request) {
  return new Promise(function (resolve, reject) {
    function cb(res) {
      try {
        (0, _utils.logInfo)('onAjaxRequest - res:', res, res.response); // todo: 格式化成 与 axios 响应格式一致

        if (res && res.response) {
          var _res$response = res.response,
              headers = _res$response.headers,
              responseText = _res$response.responseText,
              statusMessage = _res$response.statusMessage,
              statusCode = _res$response.statusCode;

          if (!responseText) {
            return reject(res.response);
          } // tod: 如果 hedaer 有 set-cookie 


          headers && handleSetCookie(/^\{.*\}$/.test(headers) ? JSON.parse(headers) : headers);
          res.response.data = /^\{.*\}$/.test(responseText) ? JSON.parse(responseText) : responseText;
          request.response = res.response;
          /**
           拦截对象 与 ajax 保持一致
           */

          var resp = {
            config: request,
            data: res.response.data,
            header: headers,
            status: +statusCode,
            statusText: statusMessage
          };
          if (request.beforeResponse) request.beforeResponse(resp);
          return resolve(res.response.data);
        } else {
          return reject(res);
        }
      } catch (error) {
        (0, _utils.logWarn)('onAjaxRequest - res 解析异常', error);
        reject(error);
      }
    }

    var key = 'onAjaxRequest';
    (0, _utils.logInfo)('request-config', request);
    var param = {
      url: request.url,
      headers: request.headers,
      method: request.method,
      timeout: request.timeout,
      body: request.body || {}
    };
    (0, _bridgev2.newInvokeIosV2)(key, param, (0, _bridgev2.getCallbackNameV2)(cb, false, key));
  });
};

exports.callNativeAjax = callNativeAjax;